
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SporeDriftEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            const driftP = this.pseudoRandom(x);
            const scrollX = (curTime * 50 * (0.5 + driftP)) % spacing;
            const scrollY = (curTime * 30 * (0.5 + driftP)) % spacing;
            
            for (let y = y1; y <= y2; y += spacing / 2) {
                const size = (1 + driftP * 3) * scale;
                const glow = (Math.sin(curTime * 2 + x + y) + 1) * 0.5;
                
                const draw = () => {
                    ctx.save();
                    ctx.globalAlpha *= 0.3 + glow * 0.7;
                    ctx.beginPath();
                    ctx.arc(x + scrollX, y + scrollY, size, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
